export const FREE_TOOL_STEEL_CARDS = {
    mp: {
        title: "Market Profile",
        subtitle: "Reading this profile",
        description:
            "The Walkthrough covers Value Area, POC, Initial Balance, singles and other structures available on the chart.",
        ctaLabel: "Show me →",
        initialActiveId: "advanced-mp",
    },
    optchain: {
        title: "Options Table",
        subtitle: "New to this view?",
        description:
            "The Tools Walkthrough explains how to read the Options Table and what each section represents.",
        ctaLabel: "See walkthrough →",
        initialActiveId: "options-table",
    },
    greeks: {
        title: "Greeks",
        subtitle: "Working with Greeks?",
        description:
            "The Tools Walkthrough covers definitions, display settings and how the values are presented on Vtrender.",
        ctaLabel: "Read the guide →",
        initialActiveId: "option-greeks",
    },
    iv: {
        title: "IV",
        subtitle: "Watching implied volatility?",
        description:
            "The Walkthrough shows how IV is plotted across the session and what a move in it signals.",
        ctaLabel: "See walkthrough →",
        initialActiveId: "iv-smile",
    },
    oi: {
        title: "OI",
        subtitle: "Reading Open Interest?",
        description:
            "The Walkthrough explains how OI is displayed and how build-up and unwinding appear on the view.",
        ctaLabel: "Read the guide →",
        initialActiveId: "oi-viz",
    },
    vol: {
        title: "Volume",
        subtitle: "Following volume?",
        description:
            "The Walkthrough covers how traded volume is shown across strikes and through the session.",
        ctaLabel: "Show me →",
        initialActiveId: "total-volumes",
    },
    ppos: {
        title: "Participant positioning",
        subtitle: "Reading positioning data",
        description:
            "The Walkthrough explains what is displayed and how the participant categories are organised.",
        ctaLabel: "Learn this view →",
        initialActiveId: "participantwise",
    },
    idxtable: {
        title: "Indices",
        subtitle: "Tracking the indices?",
        description:
            "The Walkthrough covers the index views available in Free and how they are put together.",
        ctaLabel: "Read the guide →",
        initialActiveId: "indices",
    },
};

export const FREE_TOOL_STEEL_CARD_ROUTES = {
    "/market-profile": "mp",
    "/options-table": "optchain",
    "/greek-chart": "greeks",
    "/index-table": "idxtable",
    "/position-table": "ppos",
};

export const FREE_TOOL_STEEL_CARD_ROUTE_PATTERNS = [
    { pattern: /_Strike_IV$/i, toolKey: "iv" },
    { pattern: /_Options_OI_Change_Charts$/i, toolKey: "oi" },
    { pattern: /_Strike_OI$/i, toolKey: "oi" },
    { pattern: /_Options_Vol_Charts$/i, toolKey: "vol" },
];

export const getFreeToolSteelCardKey = (pathname = "") => {
    const normalized = pathname.replace(/\/+$/, "") || "/";

    if (FREE_TOOL_STEEL_CARD_ROUTES[normalized]) {
        return FREE_TOOL_STEEL_CARD_ROUTES[normalized];
    }

    const match = FREE_TOOL_STEEL_CARD_ROUTE_PATTERNS.find(({ pattern }) =>
        pattern.test(normalized),
    );
    return match?.toolKey ?? null;
};

export const getSteelCardInitialActiveId = (toolKey) =>
    FREE_TOOL_STEEL_CARDS[toolKey]?.initialActiveId ?? "overview";

/** Apply tool_cards_popup from a /chart/mp response. */
export function applySteelCardTool(responseData, setSteelCardTool) {
    const tool = responseData?.tool_cards_popup?.trim().toLowerCase();
    if (!tool || !FREE_TOOL_STEEL_CARDS[tool]) return;

    setSteelCardTool?.(tool);
}
